// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2K6kd","col":"styles_col__ZgEv1"};